import React, { useContext, useState, useEffect } from 'react';
import './editExp.scss';

import Input from '../shared/components/FormElements/Input';
import DateInput from '../shared/components/FormElements/dateInput';
import Textarea from '../shared/components/FormElements/textarea';
import Button from '../shared/components/FormElements/Button';
import useHttpClient from '../shared/hooks/useHttpClient';
import { AuthContext } from '../shared/context/auth-context';
import ImageUploadMulti from '../shared/components/FormElements/imageUploadMulti';
import { connect } from 'react-redux';
import { setAlert } from '../redux/alert/alert-actions';
import { closeEditExp } from '../redux/editExp/editExp-actions';
import { updateOneExpHome } from '../redux/homepage/homepage-actions';
import { updateOneExp } from '../redux/profile/profile-actions';
import { MoonLoader } from 'react-spinners';
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'


const EditExp = ({closeEditExp, setAlert, inProfilePage, inHomepage,
  editExp, updateOneExp, updateOneExpHome}) => {

  const auth = useContext(AuthContext);

  const {isLoading, error, sendRequest} = useHttpClient();

  const [uploadImages, setUploadImages] = useState(false);

  const [addEmojiOpen, setAddEmojiOpen] = useState(false);

  const [formData, setFormData] = useState({
    expId: '', expTitle: '', expCity: '',
    expDate: '', expDes: '', expLocationLat: '', expLocationLng: '',
    expPhoto1: '', expPhoto2: '', expPhoto3: '',expPhoto4: '', expPhoto5: ''
  });

  useEffect(() => {
    setFormData({
      expId: editExp.expId,
      expTitle: editExp.expTitle,
      expCity: editExp.expCity,
      expDate: editExp.expDate,
      expDes: editExp.expDes,
      expLocationLat: editExp.expLocationLat,
      expLocationLng: editExp.expLocationLng,
      expPhoto1: editExp.expPhoto1,
      expPhoto2: editExp.expPhoto2,
      expPhoto3: editExp.expPhoto3,
      expPhoto4: editExp.expPhoto4,
      expPhoto5: editExp.expPhoto5
    })
  }, []);

  const handleChange = event => setFormData({
    ...formData,
    [event.target.name]: event.target.value
  });

  const addEmoji = event => setFormData({ 
    ...formData,
    expDes: formData.expDes + event.native
  });

  const handleChangeImages = (a,b,c,d,e) => setFormData({
    ...formData,
    'expPhoto1': a,
    'expPhoto2': b,
    'expPhoto3': c,
    'expPhoto4': d,
    'expPhoto5': e
  });

  const removePhotosEditExp = () => setFormData({
    ...formData,
    expPhoto1: '',
    expPhoto2: '',
    expPhoto3: '',
    expPhoto4: '',
    expPhoto5: ''
  });
  

  const handleSubmit = async event => {
    event.preventDefault();

    if (formData.expTitle.length > 30) {
      return setAlert('Title is more than 30 letters', 'Error')
    }
    
    try {

      const newFormData = new FormData();
      newFormData.append('expTitle', formData.expTitle);
      newFormData.append('expCity', formData.expCity);
      newFormData.append('expDate', formData.expDate);
      newFormData.append('expDes', formData.expDes);

      newFormData.append('expLocationLat', formData.expLocationLat || '');
      newFormData.append('expLocationLng', formData.expLocationLng || ''); 

      newFormData.append('expImages', formData.expPhoto1 || '');
      newFormData.append('expImages', formData.expPhoto2 || ''); 
      newFormData.append('expImages', formData.expPhoto3 || '');
      newFormData.append('expImages', formData.expPhoto4 || '');
      newFormData.append('expImages', formData.expPhoto5 || '');
      
 
      let responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/upExp/${formData.expId}`,
      'PATCH', newFormData, { Authorization: 'Bearer ' + auth.token });
      
      setAlert(responseData.edit, 'Success');
      inProfilePage && updateOneExp(responseData.exp);
      inHomepage && updateOneExpHome(responseData.exp);
      closeEditExp();
      !inProfilePage && !inHomepage && window.location.reload(false);
    }catch(err) {} 
    
  };

  error && setAlert(error, 'Error');
  
  return ( 
    <div className='edit-exp'>
      <form className='xxxx' onSubmit={handleSubmit}  >
        <div style={{display: 'flex'}} >
          <Input  
          name='expTitle'
          label='Title*'
          value={formData.expTitle}
          onChange={handleChange}
          note='required'
          placeholder="less than 30 letter"
          style={{width: '100%'}}
          />
          <DateInput 
          name='expDate'
          label='Date'
          value={formData.expDate}
          onChange={handleChange}
          style={{width: '100%'}}
          />
        </div>
        <div style={{display: 'flex'}} >
          
          
        </div>
        
        <div style={{display: 'flex', width: '100%'}} >
          <div style={{width: '50%'}} >
          <Input 
          name='expCity'
          label='City'
          value={formData.expCity}
          onChange={handleChange}
          style={{width: '100%'}}
          />
          </div>
          <div style={{display: 'flex', width: '50%'}} >
          <Input 
          name='expLocationLat'
          label='lat'
          value={formData.expLocationLat}
          onChange={handleChange}
          style={{width: '100%'}}
          />

          <Input 
          name='expLocationLng'
          label='lng'
          value={formData.expLocationLng}
          onChange={handleChange}
          style={{width: '100%'}}
          />
          </div>
        </div>
        
        <Textarea
        name='expDes' 
        rows='5'
        value={formData.expDes}
        onChange={handleChange}
        label='Travel Description*'
        style={{resize: 'none', width: '100%'}}
        />
        {addEmojiOpen && 
        <Picker onSelect={addEmoji} set='facebook' showPreview={false} 
        style={{position: 'absolute', bottom: '60px', left: '300px'}}
        emojiSize={20} title={false} sheetSize='16' emoji=''
        showSkinTones={false} />}

        <div className='edit-footer' >
          <Button className='button but__flex button__post'
          style={{ width: '100px'}}
          type='submit' >
            {isLoading ? (<MoonLoader loading={isLoading} size={20} />) : ('Save')}
          </Button>
          <Button className='button but__flex button__post' 
          style={{ width: '100px', backgroundColor: 'white',
          border: '1px solid black', color: 'black', marginLeft: '10px'}}
          type='button' 
          onClick={() => closeEditExp()} >
            Close
          </Button>
          <i onClick={() => setAddEmojiOpen(!addEmojiOpen)} className='smile outline icon emoji-button'></i>
        </div>
        <div className='edit-footer' >
          {formData.expPhoto1 && 
          <span className='del-all-imag'
          onClick={() => removePhotosEditExp()}
          >delete all images</span>}
          {!formData.expPhoto1 && 
          <div style={{marginLeft: '10px', marginTop: '7px'}} >
          <i onClick={() => setUploadImages(true)}
          className='images outline icon green'></i>
          </div>}
          {uploadImages && !formData.expPhoto1 &&
          <ImageUploadMulti
          handleChangeImages={handleChangeImages}
          removeImage={removePhotosEditExp}
          expPhoto1={formData.expPhoto1}
          editExp />} 
        </div>
      </form>
    </div>
  )
};

const mapDispatchToProps = {
  setAlert, closeEditExp, updateOneExp, updateOneExpHome
};

const mapStateToProps = state => ({
  editExp: state.editExp,
  inHomepage: state.homepage.inHomepage,
  inProfilePage: state.profile.inProfilePage
});

export default connect(mapStateToProps, mapDispatchToProps)(EditExp); 
